<div class="w-full py-6 lg:py-8">
  <!-- Search Input using reusable SearchBarComponent - now at 1/5 width -->
  <div class="flex w-full flex-row items-center gap-2 sm:gap-5">
    <div class="w-full sm:w-2/3 md:w-1/2 lg:w-2/5">
      <dhp-search-bar
        [placeholder]="'pages.home.searchPlaceholder' | translate"
        [searchTerm]="searchTerm()"
        (searchOutput)="onSearchTermChange($event ?? '')"
      ></dhp-search-bar>
    </div>
    <div class="sm:w-1/3 md:w-1/2 lg:w-3/5">
      <dhp-filter-group
        [articleAmount]="totalArticles()"
        (resetFilters)="onResetFilters()"
      >
        <div class="flex flex-nowrap gap-3" desktopFilters>
          <dhp-date-range-filter
            (filterOutput)="onDateRangeChange($event)"
          ></dhp-date-range-filter>
          <dhp-source-select-filter
            [selectionAndEssenceId]="magazineId()"
            (selectedSources)="onSourcesChange($event)"
          ></dhp-source-select-filter>
          <dhp-article-type-select-filter
            [selected]="articleTypesFilter()"
            (selectedArticleTypes)="onArticleTypesChange($event)"
          ></dhp-article-type-select-filter>
        </div>
        <div mobileFilters>
          <dhp-date-range-filter
            (filterOutput)="onDateRangeChange($event)"
          ></dhp-date-range-filter>
          <dhp-source-select-filter
            [selectionAndEssenceId]="magazineId()"
            (selectedSources)="onSourcesChange($event)"
          ></dhp-source-select-filter>
          <dhp-article-type-select-filter
            [selected]="articleTypesFilter()"
            (selectedArticleTypes)="onArticleTypesChange($event)"
          ></dhp-article-type-select-filter>
        </div>
      </dhp-filter-group>
    </div>
  </div>
  <!-- Loading or Error State -->
  @if (loading() || error()) {
    <div class="my-8">
      <!-- Loading state - using the same style as home page -->
      @if (loading()) {
        <div class="flex flex-col items-center justify-center space-y-4 py-12">
          <div
            class="h-10 w-10 animate-spin rounded-full border-4 border-orange-500/30 border-t-orange-500"
          ></div>
          <p class="text-neutral-600">
            {{ 'common.loading.default' | translate }}
          </p>
        </div>
      }
      <!-- Error state -->
      @if (error()) {
        <div class="text-center text-error-text">
          {{ error() }}
        </div>
      }
    </div>
  }

  <!-- Articles section with counter and horizontal line -->
  @if (!loading() && !error() && articles().size > 0) {
    <div class="mt-6">
      <!-- Results counter -->
      <div class="mb-3 text-4xl leading-relaxed font-medium text-primary-text">
        {{ totalArticles() }} {{ 'components.search.resultsFound' | translate }}
      </div>
      <!-- Horizontal line -->
      <div class="border-b border-heading-border"></div>
      <!-- Article list -->
      @if (!loading() && !error() && articles().size > 0) {
        @let articleArray = Array.from(articles());
        <dhp-article-list
          [articles]="articleArray"
          [embedContext]="'selectieAndEssentie'"
        ></dhp-article-list>
      }
      <!-- Pagination using the shared pagination component -->
      @if (paginationConfig().totalPages > 0) {
        <dhp-pagination [config]="paginationConfig()"></dhp-pagination>
      }
    </div>
  }

  <!-- No Articles -->
  @if (!loading() && !error() && articles().size === 0) {
    <div class="my-8">
      <!-- Results counter for zero results -->
      <div
        class="mb-3 border-heading-border text-4xl leading-relaxed font-medium"
      >
        0 {{ 'components.search.resultsFound' | translate }}
      </div>
      <!-- Horizontal line -->
      <div class="mb-6 border-b border-secondary-border"></div>
      <div class="text-center text-gray-500">
        {{ 'components.magazineAndJournalsDetail.noArticlesFound' | translate }}
      </div>
    </div>
  }
</div>
